import { useEffect, useRef } from 'react';

// Fires the callback function when the given state changes
export const useStateChangeEffect = <T>(
  callback: (oldState: T, newState: T) => void,
  state: T,
) => {
  const stateRef = useRef(state);

  useEffect(() => {
    if (state !== stateRef.current) {
      callback(stateRef.current, state);
      stateRef.current = state;
    }
  }, [state, callback]);
};
